import createGlobalState from "@ui/lib/createGlobalState";
import type { FaultEventStatus } from "diagnostics-domain/faultEvent";
import * as io from "io-ts";

const faultEventStatus = {
  TO_BE_ANALYSED: null,
  ONGOING: null,
  ACTION_IDENTIFIED: null,
  CLOSED: null,
} satisfies Record<FaultEventStatus, null>;

const selectedSidePanelFaultEvent = io.union([
  io.strict({
    type: io.literal("details"),
    tab: io.union([io.literal("fault"), io.literal("history")]),
  }),
  io.strict({
    type: io.literal("comments"),
  }),
  io.strict({
    type: io.literal("activity"),
  }),
  io.intersection([
    io.strict({
      type: io.literal("faultEventDetails"),
    }),
    io.partial({
      focusField: io.keyof({
        actionIdentified: null,
        status: null,
      }),
      initialStatus: io.keyof(faultEventStatus),
    }),
  ]),
]);

export const useSelectedSidePanelFaultEvent = createGlobalState({
  storage: "session",
  key: "useSelectedSidePanelFaultEvent3",
  type: selectedSidePanelFaultEvent,
  defaultValue: {
    type: "details",
    tab: "fault",
  },
  scoped: true,
});
export type SelectedSidePanelFaultEvent = io.TypeOf<typeof selectedSidePanelFaultEvent>;
export type FaultEventSidePanelFocusField = Extract<
  SelectedSidePanelFaultEvent,
  { type: "faultEventDetails" }
>["focusField"];
